<template>
<div>
  <div class="radio">
    <label>
      <input type="radio" name="revealAtChoice" :checked="value === 'immediate'" @click="setValueTo('immediate')">
      {{ $t("marker.reveal_immediate") }}
    </label>
  </div>
  <div class="radio">
    <label>
      <input type="radio" name="revealAtChoice" :checked="value === 'eventstart'" @click="setValueTo('eventstart')">
      {{ $t("marker.reveal_event_start") }}
    </label>
  </div>
</div>
</template>

<script>
export default {
  props: ['value'],
  methods: {
    setValueTo (newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>

<style>
</style>
